import { Controller } from '@hotwired/stimulus';

export default class GtmEventsController extends Controller {
  static values = { events: Array, debug: Boolean };

  connect() {
    window.dataLayer = window.dataLayer || [];
    this.pushEventsToDataLayer();
  }

  pushEventsToDataLayer() {
    this.eventsValue.forEach((event) => {
      if (!event && !event.event) {
        console.warn('Skipping invalid GTM event:', event);
        return;
      }

      if (!!this.debugValue) console.log('Pushing GTM event:', event);

      window.dataLayer.push(event);
    });
  }
};
